// extracted by mini-css-extract-plugin
module.exports = {"desktop":"HeaderStyles-module__desktop___wRAAL","mobile":"HeaderStyles-module__mobile___Gqc-C"};